var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppsShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8021_9665)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8021_9665",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8021_9665)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_8021_9665)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8021_9665",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 12,
    height: 12
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6H6V18H18V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8021_9665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25 14.7502H6V16.5003C6 16.8981 6.15803 17.2796 6.43934 17.5609C6.72064 17.8422 7.10217 18.0003 7.5 18.0003H9.25V14.7502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 14.7502H14.75V18.0003H16.4999C16.8977 18.0003 17.2793 17.8422 17.5606 17.5609C17.8419 17.2796 17.9999 16.8981 17.9999 16.5003V14.7502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 10.3748H6V13.6248H9.25V10.3748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 10.3748H14.75V13.6248H17.9999V10.3748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 6H7.5C7.10217 6 6.72064 6.15803 6.43934 6.43934C6.15803 6.72064 6 7.10217 6 7.5V9.25H9.25V6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.625 14.7502H10.375V18.0003H13.625V14.7502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.625 10.3748H10.375V13.6248H13.625V10.3748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.625 6H10.375V9.25H13.625V6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4999 6H14.75V9.25H17.9999V7.5C17.9999 7.10217 17.8419 6.72064 17.5606 6.43934C17.2793 6.15803 16.8977 6 16.4999 6Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8021_9665",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8021_9665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsShort);
export default __webpack_public_path__ + "static/media/Apps-Short.ff482042edd2253c6bbc9fabfc0deb07.svg";
export { ForwardRef as ReactComponent };